// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3170":"a4be87b6","6342":"41e70d2d","9571":"85edabdc"}[chunkId] + ".chunk.css";
};